import CollaboratorForm from './CollaboratorForm';

export default CollaboratorForm;
